import axios from 'axios'
import { createApp } from 'vue'
import { ItemAddToCart } from '~/js/components/buttonAddToCart/index.vue'
import FButtonAddToCart from '~/js/components/buttonAddToCart'
import StepContainer from '~/js/templates/page/customProducts/components/stepContainer.vue'
const ID_ARTICLE_SIMULATION = 'js-articleSimulation'

const getArrayLength = (array) => {
  return array.length - [...array].reverse().findIndex((value) => value != null)
}

document.addEventListener('DOMContentLoaded', async () => {
  const elementArticleSimulation = document.getElementById(
    ID_ARTICLE_SIMULATION
  )
  if (!elementArticleSimulation) return

  const dataset = elementArticleSimulation.dataset
  const storefrontAccessToken = dataset.storefrontAccessToken
  if (!storefrontAccessToken) return

  const titles = dataset.titles.split('#').map((title) => title || null)
  const products = dataset.products
    .split('#')
    .map((product) => (product ? JSON.parse(product) : null))
  const excludeCompletedImage = dataset.excludeCompletedImage.split('#')
  const stepLength = Math.max(getArrayLength(titles), getArrayLength(products))
  const steps = new Array(stepLength).fill({}).map((_, index) => {
    return {
      title: titles[index] || '',
      productGids: products[index] || [],
      excludeCompletedImage: excludeCompletedImage[index] === 'true',
    }
  })

  const query = `
    query($ids:[ID!]!) {
      nodes(ids: $ids) {
        ... on Product {
          handle
          productGid: id
          title
          featuredImage {
            url
          }
          imageSimulation: metafield(namespace: "additional", key: "simulator_image") {
            reference {
              ... on MediaImage {
                image {
                  url
                }
              }
            }
          }
          variants(first: 1) {
            edges {
              node {
                id
              }
            }
          }
        }
      }
    }`
  const variables = {
    ids: steps
      .map((step) => step.productGids)
      .flat()
      .filter((v) => v),
  }

  const { data } = await axios.post(
    '/api/unstable/graphql.json',
    {
      query,
      variables,
      retries: 3,
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
      },
    }
  )

  steps.forEach((step) => {
    const products = step.productGids
      .map((productGid) => {
        return data.data.nodes.find((node) => {
          return node?.productGid === productGid
        })
      })
      .filter((v) => v)
      .map((product) => {
        const id = Number(product?.productGid.match(/\d+/)?.[0])
        const variantId = Number(
          product.variants.edges[0]?.node.id.match(/\d+/)?.[0]
        )
        return {
          ...product,
          sku: product?.handle || '',
          id,
          image:
            product?.imageSimulation?.reference?.image?.url ||
            product?.featuredImage?.url ||
            '',
          variantId,
        }
      })
    step.products = products
  })

  createApp({
    name: 'ArticleSimulation',
    components: { StepContainer, FButtonAddToCart },
    data() {
      return {
        currentStep: null,
        selectedProducts: new Array(stepLength).fill(''),
        showCompletedImage: false,
        steps,
      }
    },
    computed: {
      completedImageUrl() {
        const filename = this.selectedProducts
          .filter((_, index) => !this.steps[index].excludeCompletedImage)
          .map((product) => product.sku)
          .join('_')
        return `//cdn.shopify.com/s/files/1/0132/7936/3136/files/${filename}.jpg`
      },
      isStepsComplete() {
        return this.selectedProducts.every((product) => !!product)
      },
      itemsAddToCart() {
        return this.selectedProducts.map((product) => {
          const id = product.id
          return new ItemAddToCart({
            ...product,
            handle: product.sku,
            id,
          })
        })
      },
    },
    mounted() {
      this.$el.parentElement.style.display = null
    },
    methods: {
      onShowCompletedImageClicked() {
        this.showCompletedImage = true
        this.$nextTick(() => {
          this.scrollTo()
        })
      },
      onProductSelected(index, product) {
        this.showCompletedImage = false
        this.selectedProducts[index] = product
        this.currentStep = index + 1
        // eslint-disable-next-line no-extra-boolean-cast
        while (!!this.selectedProducts[this.currentStep]) {
          this.currentStep++
        }
        if (this.currentStep >= this.steps.length) this.currentStep = null
        this.$nextTick(() => {
          this.scrollTo()
        })
      },
      onStepClicked(index) {
        this.currentStep = index
        this.$nextTick(() => {
          this.scrollTo()
        })
      },
      scrollTo() {
        const targetRef = Number.isInteger(this.currentStep)
          ? `step${this.currentStep}`
          : 'completed-area'
        const elementsTarget = this.$refs[targetRef]
        const elementTarget = elementsTarget.length
          ? elementsTarget[0]
          : elementsTarget
        elementTarget.scrollIntoView({
          behavior: 'smooth',
        })
      },
    },
  }).mount(elementArticleSimulation)
})
